
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { IUser } from '~/store/profile/types';
import { isEmail } from 'validator';
import SignUpModal from './SignUpModal.vue';

@Component({
  components: {
    SignUpModal,
  },
  inheritAttrs: false,
})
export default class SignUpForAlertsBtn extends Vue {
  @Prop({ type: String, default: '11' })
  readonly emailList!: string;
  @Prop({ type: String, default: '66' })
  readonly activeCampaignTag!: string;
  @Prop({ type: String, default: '' })
  readonly buttonAriaLabel!: string;
  @Prop({ type: String, default: 'accentPurple' })
  readonly buttonColor!: string;
  @Prop({ type: String, default: '' })
  readonly buttonLabel!: string;
  @Prop({ type: String })
  readonly buttonLabelSuccess!: string;
  @Prop({ type: String, default: 'white' })
  readonly textColor!: string;
  @Prop(Boolean)
  readonly outlined!: string;
  @Prop({ type: String, default: 'mdi-bell' })
  readonly icon!: string;

  @State((profile) => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  @State((profile) => profile.user, { namespace: 'profile' })
  currentUser!: IUser;

  @Mutation('toggleFilmEmailSignup')
  private toggleFilmEmailSignup!: (args: any) => void;
  @Mutation toggleSuccessSnackbar!: (payload?: boolean) => void;
  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: string) => void;
  @Mutation updateSnackbarSuccessText!: (args: string) => void;

  email = '';
  isSubscribing = false;
  hasSubscribed = false;

  emailSignupClicked() {
    if (this.loggedIn && this.currentUser?.email) {
      this.email = this.currentUser.email;
      this.subscribe();
    } else {
      this.toggleFilmEmailSignup(true);
    }
  }

  public async subscribe() {
    if (!isEmail(this.email)) {
      const errorMessage = this.$t(
        'common.notifications.pleaseEnterAValidEmail',
      ) as string;
      this.email = '';

      this.updateSnackbarErrorText(errorMessage);
      this.toggleErrorSnackbar();

      return;
    }

    this.isSubscribing = true;

    fetch(
      'https://8ut1qllg36.execute-api.us-east-1.amazonaws.com/production/handler',
      {
        method: 'POST',
        body: JSON.stringify({
          email: this.email,
          tag: this.activeCampaignTag,
          list: this.emailList,
        }),
      },
    )
      .then(async () => {
        this.updateSnackbarSuccessText(
          this.$t('components.films.filmHero.signupSuccessMessage') as string,
        );
        this.toggleSuccessSnackbar();
        this.$emit('subscribe-success');
        this.hasSubscribed = true;
      })
      .catch(() => {
        this.updateSnackbarErrorText(
          this.$t('components.films.filmHero.signupErrorMessage') as string,
        );
        this.toggleErrorSnackbar();
      })
      .finally(() => {
        this.email = '';
        this.isSubscribing = false;
        this.toggleFilmEmailSignup(false);
      });
  }
}
